import React, {useState} from 'react';
import {Menu, MenuItem, IconButton, Button, Chip, Paper, Table, TableBody, TableCell, TableContainer, TableRow, CircularProgress} from "@mui/material";
import Grid from "@mui/material/Grid2";
import TableHeader from "../layout/table/TableHeader";
import NoDataLabel from "../layout/NoDataLabel";
import ModeEditOutlineOutlinedIcon from "@mui/icons-material/ModeEditOutlineOutlined";
import CloseOutlinedIcon from "@mui/icons-material/CloseOutlined";
import BuildIcon from '@mui/icons-material/Build';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import QrCodeIcon from '@mui/icons-material/QrCode';
import ModalDelete from "../layout/ModalDelete";
import {useNavigate} from "react-router-dom";
import Constants from "../../../utils/constants";
import {helper} from "../../../utils/helper.js";
import {laveusesService} from "../../../modules/laveuses/laveuses.service";

function LaveusesTable({laveuses, ...props}) {
    const navigate = useNavigate()
    const [order, setOrder] = React.useState('desc');
    const [orderBy, setOrderBy] = React.useState('client');
    const [label, setLabel] = useState("")
    const [objectToDelete, setObjectToDelete] = useState(null)
    const [open, setOpen] = useState(false);
    const [currentLaveuse, setCurrentLaveuse] = useState(null);
    const [anchorEl, setAnchorEl] = useState(null);
    const [menuLaveuse, setMenuLaveuse] = useState(null);
    const [loadingQr, setLoadingQr] = useState(false);

    const handleOpenMenu = (event, laveuse) => {
        setAnchorEl(event.currentTarget);
        setMenuLaveuse(laveuse);
    };

    const handleCloseMenu = () => {
        setAnchorEl(null);
        setMenuLaveuse(null);
    };

    // Table head cells
    const headCells = [
        {id: 'immatriculation', label: 'Immatriculation'},
        {id: 'description', label: 'Description'},
        {id: 'telemetryProvider', label: 'Fournisseur télématique'},
        {id: 'telemetryExternalId', label: 'Identifiant télématique'},
        {id: 'operateur', label: 'Opérateur'},
        {id: 'statut', label: 'Statut'},
    ];


    const openDeleteConfirmModal = (f) => {
        setCurrentLaveuse(f)
        setLabel("Etes vous sûr de vouloir supprimer le laveuse : ")
        setObjectToDelete(f.libelle)
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
        setCurrentLaveuse(null)
    };

    const handleEditClick = (id) => {
        navigate(Constants.APP_ROUTE_ADMIN_LAVEUSES_EDIT.replace(':id', id))
    }

    const handleJournalClick = (id) => {
        navigate(Constants.APP_ROUTE_ADMIN_LAVEUSES_JOURNAL.replace(':id', id))
    }

    const handleDelete = () => {
        props.onDelete(currentLaveuse)
        handleClose()
    }

    const handleQrCodeClick = async (id) => {
        setLoadingQr(true);
        try {
            const data = await laveusesService.fetchQrCode(id);
            const imageUrl = data?.url;
            if (imageUrl) {
                window.open(imageUrl, '_blank', 'noopener,noreferrer');
            } else {
                console.error('QR Code: URL manquante dans la réponse API', data);
            }
        } catch (e) {
            console.error('Impossible de générer le QR Code:', e);
        } finally {
            setLoadingQr(false);
            handleCloseMenu();
        }
    }

    const handleRequestSort = (event, property) => {
        const isAsc = orderBy === property && order === 'asc';
        setOrder(isAsc ? 'desc' : 'asc');
        setOrderBy(property);
    };

    const getItemComparator = (item, comparator) => {
        return item[comparator];
    }
    const sortedData = () => {
        return laveuses.sort((a, b) => {
            if (order === 'asc') {
                return (getItemComparator(a, orderBy) > getItemComparator(b, orderBy)) ? 1 : (getItemComparator(b, orderBy) > getItemComparator(a, orderBy)) ? -1 : 0;
            }
            return (getItemComparator(a, orderBy) < getItemComparator(b, orderBy)) ? 1 : (getItemComparator(b, orderBy) < getItemComparator(a, orderBy)) ? -1 : 0
        });
    }


    return (
        <React.Fragment>
            <TableContainer component={Paper} className={"mt-2"}>
                <Table aria-label="laveuses table" size="small">
                    <TableHeader headCells={headCells} order={order} orderBy={orderBy}
                                 onRequestSort={handleRequestSort}/>
                    <TableBody>
                        {laveuses && laveuses.length === 0 &&
                            <TableRow>
                                <TableCell colSpan={10} align={"center"}>
                                    <NoDataLabel label={"Il n'y a encore aucun laveuse enregistrée"}/>
                                </TableCell>
                            </TableRow>
                        }
                        {laveuses && sortedData().map((laveuse) => {
                            return (
                                <React.Fragment key={laveuse.id}>
                                    <TableRow hover onClick={(e) => { handleOpenMenu(e, laveuse); }}
                                              style={{cursor: 'pointer'}}>
                                        <TableCell>
                                            {laveuse.immatriculation}
                                        </TableCell>
                                        <TableCell>
                                            {laveuse.description || "Non renseigné"}
                                        </TableCell>
                                        <TableCell>
                                            {laveuse.telemetryProvider || (laveuse.quartixId ? 'quartix' : "Non renseigné")}
                                        </TableCell>
                                        <TableCell>
                                            {laveuse.telemetryExternalId || laveuse.quartixId || "Non renseigné"}
                                        </TableCell>
                                        <TableCell>
                                            {laveuse.operateur?.libelle ?? "Non affectée"}
                                        </TableCell>
                                        <TableCell>
                                            <Chip
                                                label={helper.getLaveuseImportanceLibelle(laveuse.statut)}
                                                style={{
                                                    backgroundColor: helper.getLaveuseImportanceColor(laveuse.statut),
                                                    color: 'white'
                                                }}
                                            />
                                        </TableCell>
                                        <TableCell align="right">
                                            <IconButton
                                                aria-label="more"
                                                aria-controls="long-menu"
                                                aria-haspopup="true"
                                                onClick={(e) => {
                                                    e.stopPropagation();
                                                    handleOpenMenu(e, laveuse);
                                                }}
                                            >
                                                <MoreVertIcon />
                                            </IconButton>
                                        </TableCell>
                                    </TableRow>
                                </React.Fragment>
                            )
                        })}
                    </TableBody>
                </Table>
            </TableContainer>

            <Menu
                anchorEl={anchorEl}
                keepMounted
                open={Boolean(anchorEl)}
                onClose={handleCloseMenu}
            >
                <MenuItem onClick={() => {
                    handleEditClick(menuLaveuse.id);
                    handleCloseMenu();
                }} sx={{ color: 'success.main' }}>
                    <ModeEditOutlineOutlinedIcon fontSize="small" sx={{ mr: 1 }} /> Editer
                </MenuItem>
                <MenuItem onClick={() => {
                    handleJournalClick(menuLaveuse.id);
                    handleCloseMenu();
                }} sx={{ color: 'primary.main' }}>
                    <BuildIcon fontSize="small" sx={{ mr: 1 }} /> Journal
                </MenuItem>
                <MenuItem onClick={() => {
                    handleQrCodeClick(menuLaveuse.id);
                }} sx={{ color: 'text.primary' }} disabled={loadingQr}>
                    {loadingQr ? <CircularProgress size={20} sx={{ mr: 1 }} color="inherit" /> : <QrCodeIcon fontSize="small" sx={{ mr: 1 }} />} Générer QR Code
                </MenuItem>
                <MenuItem onClick={() => {
                    openDeleteConfirmModal(menuLaveuse);
                    handleCloseMenu();
                }} sx={{ color: 'error.main' }}>
                    <CloseOutlinedIcon fontSize="small" sx={{ mr: 1 }} /> Supprimer
                </MenuItem>
            </Menu>
            <ModalDelete label={label} onClose={handleClose} open={open} objectToDelete={objectToDelete}
                         selectedValue={currentLaveuse} onDelete={handleDelete}/>
        </React.Fragment>
    )
}

export default LaveusesTable;
